const TENANT_TICKET_CATEGORIES = [
  {
    value: "missing_documents",
    translationKey: "skorTicketMissingDocuments",
    label: "Missing documents",
    subjectPlaceholder: "Which document is missing?",
    messagePlaceholder:
      "Tell us which document is missing and any details that may help.",
  },
  {
    value: "document_classification",
    translationKey: "skorTicketDocumentClassification",
    label: "Classification of documents",
    subjectPlaceholder: "Which document was classified incorrectly?",
    messagePlaceholder:
      "Tell us which document is affected and what the correct classification should be.",
  },
  {
    value: "information_extraction",
    translationKey: "skorTicketInformationExtraction",
    label: "Information Extraction",
    subjectPlaceholder: "What information was extracted incorrectly?",
    messagePlaceholder:
      "Describe the incorrect information and the document it came from.",
  },
  {
    value: "other_profile_issues",
    translationKey: "skorTicketOtherProfileIssues",
    label: "Other profile related issues",
    subjectPlaceholder: "What profile issue can we help with?",
    messagePlaceholder:
      "Describe your profile issue and include any useful details.",
  },
];

const LANDLORD_TICKET_CATEGORIES = [
  {
    value: "personal_information",
    translationKey: "skorTicketPersonalInformation",
    label: "Personal information",
    subjectPlaceholder: "What is wrong with the personal information?",
    messagePlaceholder:
      "Describe the personal information issue and the profile it concerns.",
  },
  {
    value: "employment_information",
    translationKey: "skorTicketEmploymentInformation",
    label: "Employment information",
    subjectPlaceholder: "What is wrong with the employment information?",
    messagePlaceholder:
      "Describe the employment information issue and the profile it concerns.",
  },
  {
    value: "financial_details",
    translationKey: "skorTicketFinancialDetails",
    label: "Financial details",
    subjectPlaceholder: "What is wrong with the financial details?",
    messagePlaceholder:
      "Describe the financial details issue and the profile it concerns.",
  },
  {
    value: "effort_rate",
    translationKey: "skorTicketEffortRate",
    label: "Effort rate",
    subjectPlaceholder: "What is your question about the effort rate?",
    messagePlaceholder:
      "Describe the effort rate you see and what you would like us to review.",
  },
  {
    value: "documents",
    translationKey: "skorTicketDocumentsCategory",
    label: "Documents",
    subjectPlaceholder: "Which document is this about?",
    messagePlaceholder:
      "Tell us which document is affected and what the issue is.",
  },
  {
    value: "forensic_issue",
    translationKey: "skorTicketForensicIssue",
    label: "Forensic issue",
    subjectPlaceholder: "What forensic issue can we help with?",
    messagePlaceholder:
      "Describe the forensic issue and the document or profile it concerns.",
  },
  {
    value: "bug",
    translationKey: "skorTicketBug",
    label: "Platform error",
    subjectPlaceholder: "What is not working correctly?",
    messagePlaceholder:
      "Describe what happened, what you expected, and the steps to reproduce the issue.",
  },
  {
    value: "account_access",
    translationKey: "skorTicketAccountAccess",
    label: "Account access",
    subjectPlaceholder: "What account access problem are you having?",
    messagePlaceholder:
      "Tell us what happens when you try to access your account. Do not include passwords or access codes.",
  },
  {
    value: "billing",
    translationKey: "skorTicketBilling",
    label: "Billing and credits",
    subjectPlaceholder: "What is your billing or credits question?",
    messagePlaceholder:
      "Describe the charge, invoice, or credit balance you would like us to review.",
  },
  {
    value: "integration_api",
    translationKey: "skorTicketIntegrationApi",
    label: "Integration / API",
    subjectPlaceholder: "Which integration or API needs help?",
    messagePlaceholder:
      "Describe the integration, the request or action, and any error message. Do not include API keys or tokens.",
  },
  {
    value: "product_question",
    translationKey: "skorTicketProductQuestion",
    label: "Product question",
    subjectPlaceholder: "What would you like to know about Skor?",
    messagePlaceholder:
      "Tell us which feature you have a question about and what you would like to do.",
  },
  {
    value: "feature_request",
    translationKey: "skorTicketFeatureRequest",
    label: "Suggestion",
    subjectPlaceholder: "What would you like us to improve or add?",
    messagePlaceholder: "Describe your suggestion and how it would help you.",
  },
  {
    value: "other",
    translationKey: "skorTicketOther",
    label: "Other",
    subjectPlaceholder: "How can we help?",
    messagePlaceholder:
      "Describe your question or issue and include any useful details.",
  },
];

// Combined list kept for placeholder/message lookup of any stored category.
export const SKOR_TICKET_CATEGORIES = [
  ...TENANT_TICKET_CATEGORIES,
  ...LANDLORD_TICKET_CATEGORIES,
];

export const TENANT_CATEGORIES = TENANT_TICKET_CATEGORIES;
export const LANDLORD_CATEGORIES = LANDLORD_TICKET_CATEGORIES;

// Categories shown in the ticket form depend on who is reporting (the
// logged-in user type), not on whose profile the ticket is linked to — so a
// landlord viewing a tenant profile still sees the landlord list.
export const getTicketCategoriesForUserType = (usertype) =>
  usertype === "tenant" ? TENANT_TICKET_CATEGORIES : LANDLORD_TICKET_CATEGORIES;

export const DOCUMENT_REQUIRED_CATEGORIES = [
  "document_issue",
  "fraud",
  "missing_documents",
  "document_classification",
];
